import * as React from "react";
import {useState, useEffect, useRef} from 'react';
import { jfetch, toast } from "../../utils";
import Modal from "../core/Modal"
import Button from "../core/Button"
import NumberFormat from 'react-number-format';
import useDashboard  from "../../hooks/useDashboard";



interface IProps {
  userContext:any;
}

function MonthlyServices(props: IProps){
  const [services, setServices] = useState([]); 
  const [originalServices, setOriginalServices] = useState([])
  const [showModal, setShowModal] = useState(false); 
  const {categories, setCategories} = useDashboard()

  async function getServices(org_id){
    jfetch
      .get(`/organizations/${org_id}/quote_calculator/services`, {for_project:"false"})
      .then((resp) => {
        setServices(resp.services)
        setOriginalServices(resp.services)
      })
  }

  useEffect(() => {
    getServices(props.userContext.org.id);
  }, []);

  return (
    <>
    <a className="quote-blocks-popup"
      onClick={() => {
        setShowModal(true);
      }}
    >
      <span className="cool-blue">{originalServices.length}</span> Monthly Services <i className="fa fa-pencil"/>
    </a>
    <Modal
      title={"Monthly Services"}
      open={showModal}
      close={() => setShowModal(false)}
      submittable={false}
      isLarge={true}
      disallowClickOutside={true}
    >
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-8 form-inline text-left">
            <div className="form-group" style={{width:'100%'}}>
              <div className="input-group" style={{width:'100%'}}>
                <div className="input-group-addon" style={{width:'42px'}}>
                  <i className="fa fa-search"></i>
                </div>
                <input 
                  type="text" 
                  className="form-control" 
                  placeholder="Search.." 
                  onChange={(e) => {
                    let clone_services = [...originalServices]
                    let input_text = e.target.value.toLowerCase() 
                    clone_services = clone_services.filter( service => service.name.toLowerCase().includes(input_text))
                    setServices(clone_services)
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <NewService 
          userContext={props.userContext}
          categories={categories}
          updateServices={(s) => {
            setServices(s)
            setOriginalServices(s)
          }} 
        />
        <div className="quote-entries-list">
          <br/>
          { services.map((s) => 
            <Service 
              service={s} 
              key={s.id} 
              userContext={props.userContext}
              categories={categories}
              updateServices={(s) => {
                setServices(s)
                setOriginalServices(s)
              }}
              close={() => setShowModal(false)}
            />
          )}
        </div>
      </div>
    </Modal>
    </>
  )
}

interface S{
  id:number;
  name: string,
  default_hours: string,
  pay_rate:string,
  billable_rate: string,
  margin:string,
  created_at: string,
  updated_at: string,
  user_id: number,
  category: string,
  quote_calculator_category_id: string
}

interface ServiceIProps {
  service:S;
  userContext:any;
  updateServices:any;
  close:Function;
  categories:any;
}

function Service(props:ServiceIProps){
  const [edit, setEdit] = useState(false);
  const [service, setService] = useState(props.service)
  const [name, setName] = useState(props.service.name)
  const [hours, setHours] = useState(props.service.default_hours)
  const [category, setCategory] = useState(props.service.quote_calculator_category_id)
  
  function toggleEdit(){
    setEdit(!edit)
  }

  useEffect(() => {
    let s = service
    s.name = name
    s.default_hours = hours
    s.quote_calculator_category_id = category
    props.categories.forEach(c => {
      if(c.id == +category){
        s.category = c.name
      }
    });
    setService(s) 
  }, [name, hours, category])

  return (
    <div className="row quote-money-row">
      <a className="edit-pencil">
        { edit ? <i className="fa fa-ban" onClick={() => toggleEdit()}></i> : <i className="fa fa-pencil" onClick={() => toggleEdit()}></i> }
      </a>
      <div className="col-lg-4" style={{textAlign:'left'}}>
        {edit ? (
          <input 
            type="text" 
            className="form-control" 
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        ) : (
          service.name
        )}
      </div>
      <div className="col-lg-2">
        {edit ? (
          <NumberFormat 
            value={hours}
            className="form-control"
            displayType="input"
            fixedDecimalScale={true} 
            decimalScale={2}
            onValueChange={(values) => setHours(values.value)}
          />
        ) : (
          service.default_hours
        )}
      </div>
      <div className="col-lg-2" style={{overflow:'hidden'}}>
        {edit ? (
          <select value={category} onChange={(e) => setCategory(e.target.value)} >
            <option key={0} value="">select one</option>
            {props.categories.map((category) => {
              return (
                <option key={category.id} value={category.id}>{category.name}</option>
              )
            })}
          </select>
        ) : (
          service.category
        )}
      </div>      
      <div className="col-lg-2">
        {edit ? (
          <a 
            className='update-entry'
            onClick={() => {
              jfetch
              .patch(`/organizations/${props.userContext.org.id}/quote_calculator/services/${props.service.id}`, {service:service})
              .then((resp) => {
                toggleEdit();
              })
              .catch((err) => {
                props.close()
                toast.error("cannot update service.")
              })              
            }}
          >
            Update
          </a>
        ) : (
          <a
          className='delete-entry'
          onClick={() => {
            jfetch
            .delete(`/organizations/${props.userContext.org.id}/quote_calculator/services/${props.service.id}?for_project=false`)
            .then((resp) => {
              props.updateServices(resp.services)
            })
            .catch((err) => {
              props.close()
              toast.error("cannot delete service since it is associated with a calculator")
            })
          }}
        >
          Delete
        </a>
        )}
      </div>
    </div>    
  )
}

interface NewServiceProps{
  updateServices:any;
  userContext:any;
  categories:any;
}

function NewService(props:NewServiceProps){
  const [name, setName] = useState('')
  const [category, setCategory] = useState('')
  const [hours, setHours] = useState(0)
  const [payRate, setPayRate] = useState(0)
  const [billRate, setBillRate] = useState(0)
  const [margin, setMargin] = useState(0)
  const [isLoading, setIsLoading] = useState(false)
  const [thumbnail, setThumbnail] = useState(null)
  const imageInputRef:any = useRef()  

  //updates margin when pay or bill rate change.
  useEffect(() => {
    setMargin((billRate - payRate) / billRate)
  }, [payRate, billRate])

  function create_service(org_id){
    setIsLoading(true);
    const formData = new FormData();
    formData.append("service[name]", name);
    formData.append("service[default_hours]", hours.toString());
    formData.append("service[billable_rate]", billRate.toString());
    formData.append("service[pay_rate]", payRate.toString());
    formData.append("service[margin]", margin.toString());
    formData.append("service[user_id]", props.userContext.user.id);
    formData.append("service[for_project]", 'false');
    formData.append("service[quote_calculator_category_id]", category);
    if(thumbnail != null){
      formData.append("service[thumbnail]", thumbnail)
    }
    jfetch.post(`/organizations/${org_id}/quote_calculator/services`, formData)
    .then((resp) => {
      setIsLoading(false);
      setName('')
      setHours(0)
      setPayRate(0)
      setBillRate(0)
      setMargin(0)
      setCategory('')
      imageInputRef.current.value = "";
      props.updateServices(resp.services)
    })
    .catch((err) => {
    })
  }

  function setFile(event){
    setThumbnail(event.target.files[0])
  }

  return (
    <>
      <div className="row qc-entry-create">
        <div className="col-lg-4">
          <label>Name</label>
          <input 
            type="text" 
            className="form-control" 
            onChange={(e) => setName(e.target.value) }
            value={name}
          />
        </div>
        <div className="col-lg-2">
          <label>Hours</label>
          <NumberFormat 
            value={hours}
            className="form-control"
            displayType={'input'} 
            fixedDecimalScale={true} 
            decimalScale={2}
            onValueChange={(values) => setHours(values.floatValue)}
          />
        </div>
        <div className="col-lg-2" style={{overflow:'hidden'}}>
          <select value={category} onChange={(e) => setCategory(e.target.value)} style={{maxWidth:'100%', fontWeight:300}}>
            <option key={0} value="">select one</option>
            {props.categories.map((category) => {
              return (
                <option key={category.id} value={category.id}>{category.name}</option>
              )
            })}
          </select>
        </div>      
        <div className="col-lg-2">
          <Button 
            color="primary"
            loading={isLoading}
            onClick={() => {
              create_service(props.userContext.org.id);
            }}
          >
            Add Service
          </Button>
        </div>    
      </div>
      <div className="row">
        <div className="col-lg-12">
          <p className="text-left">Upload Image <i className="fa fa-upload"/> </p>
          <input style={{maxWidth:'33%'}} type="file" name="thumbnail" id="thumbnail" accept=".jpg,.jpeg,.gif,.png" onChange={setFile.bind(this)} ref={imageInputRef} />
        </div>
      </div>
    </>
  )
}

export default MonthlyServices


// WEBPACK FOOTER //
// ./app/javascript/components/quote_calculator/MonthlyService.tsx